import { Formik, FieldArray, Field } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { AiFillMinusSquare } from "react-icons/ai";
import CustomEditor5 from "../../../../utils/ckEditor5";
import { useEffect, useRef } from "react";
import Alert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { clearCountryFaq } from "../../../../../store/slices/country";
import SaveAndSaveNext from "../../../utils/saveAndSaveNext";

const FaqsForm = (props) => {
  const firstErrorRef = useRef(null);
  const dispatch = useDispatch();
  const { putCountryFaqError, message, putCountryFaqLoading } = useSelector(
    (state) => state.cmsCountry
  );
  useEffect(() => {
    if (message) {
      setTimeout(() => {
        dispatch(clearCountryFaq());
      }, 5000);
    }
  }, [message]);
  return (
    <div>
      <div className={"notification_popup"}>
        {message && (
          <Alert severity={putCountryFaqError ? `error` : `success`}>
            {" "}
            {message}
          </Alert>
        )}
      </div>

      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validate={(values) => {
          const errors = {};
            values.faq.forEach((qna, index) => {
              if (qna.question) {
                if (!qna.answer) {
                  errors[`faq.${index}.answer`] = "Answer is required.";
                }
              }
              if (qna.answer) {
                if(!qna.question){
                  errors[`faq.${index}.question`] = "Question is required.";
                }
              }
              if (qna.answer.trim().split(/\s+/).length > 500) {
                errors[
                  `faq.${index}.answer`
                ] = `Word limit Exceeded please enter only 500 words
                ${500 - qna.answer.trim().split(/\s+/).length}`;
              }
            });
          
          return errors;
        }}
        onSubmit={(values) => {
          props.submit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          setTouched,
          handleBlur,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            {values.faq?.length > 0 && (
              <div className={"basic_details_country"}>
                <div className={"examfilter"}>
                  <h4 className={"examfilter_heading"}>Landing Page FAQs</h4>
                  <FieldArray name="faq">
                    {({ insert, remove, push }) => (
                      <div>
                        {values.faq?.map((element, index) => (
                          <>
                            <Row>
                              <Col>
                                <Form.Group
                                  className="mb-3"
                                  controlId={`faq.${index}.question`}
                                >
                                  <Form.Label>Question</Form.Label>
                                  <Field
                                    name={`faq.${index}.question`}
                                    type="text"
                                    className={"input_pd"}
                                    component={Form.Control}
                                    value={values.faq[index].question}
                                    onBlur={handleBlur}
                                    onChange={(e) =>
                                      setFieldValue(
                                        `faq.${index}.question`,
                                        e.target.value
                                      )
                                    }
                                  />
                                  {errors[`faq.${index}.question`] &&
                                    touched["faq"]?.[index]?.[`question`] && (
                                      <div
                                        ref={firstErrorRef}
                                        className="error"
                                      >
                                        {errors[`faq.${index}.question`]}
                                      </div>
                                    )}
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={9}>
                                <Form.Group
                                  className="mb-3"
                                  controlId={`faq.${index}.answer`}
                                >
                                  <Form.Label>Answer</Form.Label>
                                  <CustomEditor5
                                    initData={values.faq[index].answer}
                                    onBlur={handleBlur}
                                    onChange={(d) => {
                                        setFieldValue(
                                          `faq.${index}.answer`,
                                          d
                                        );        
                                    }}
                                  />
                                  {errors[`faq.${index}.answer`] &&
                                    touched[`faq`]?.[index]?.[`answer`] && (
                                      <div
                                        ref={firstErrorRef}
                                        className="error"
                                      >
                                        {errors[`faq.${index}.answer`]}
                                      </div>
                                    )}
                                </Form.Group>
                              </Col>
                              <Col className="publish_status">
                                <Form.Group
                                  className="mt-4"
                                  controlId="publish_status"
                                >
                                  <Field
                                    type="checkbox"
                                    name={`faq.${index}.status`}
                                    className={"mode_checkbox"}
                                    component={Form.Check}
                                    checked={values.faq[index].status}
                                    onChange={(e) =>
                                      setFieldValue(
                                        `faq.${index}.status`,
                                        !values.faq[index].status
                                      )
                                    }
                                  />{" "}
                                  Publish Status
                                </Form.Group>
                              </Col>
                              <Col className="bottom_right_button_container">
                                <div className={"imageField_fieldArray"}>
                                  <div className={"imageField_add"}>
                                    {values.faq?.length > 1 && (
                                      <span
                                        className={"imageField_minus_icon"}
                                        onClick={() => {
                                          remove(index);
                                        }}
                                      >
                                        <AiFillMinusSquare />
                                      </span>
                                    )}
                                    {index == values.faq?.length - 1 && (
                                      <span
                                        className={"imageField_add_icon"}
                                        onClick={() =>
                                          push({
                                            answer: "",
                                            question: "",
                                            status: false,
                                          })
                                        }
                                      >
                                        <BsFillPlusSquareFill />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </div>
              </div>
            )}
            <div className={"domain"}>
              <div className={"examfilter"}>
                <Row>
                  {values.last_updated && (
                    <span>Last Updated date: {values.last_updated}</span>
                  )}
                </Row>
                <Row>
                  {values.updated_by && (
                    <span>Updated by: {values.updated_by} </span>
                  )}
                </Row>
                <Row>
                  <Col className="mt-3">
                    <SaveAndSaveNext
                      firstErrorRef={firstErrorRef}
                      setTouched={setTouched}
                      errors={errors}
                      setSaveAndNext={props.setSaveAndNext}
                      loading={putCountryFaqLoading}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default FaqsForm;
